// src/context/AuthContext.jsx
// context food
import React, { createContext, useState, useContext, useEffect } from "react";
// ...

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // ATENÇÃO A ESTA LINHA:
  // O estado inicial deve ser definido pela VERIFICAÇÃO do LocalStorage.
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    // Retorna TRUE se a chave 'ClientToken' existir, caso contrário, retorna FALSE.
    return !!localStorage.getItem("ClientToken");
  });

  // Se você tinha apenas: const [isAuthenticated, setIsAuthenticated] = useState(true);
  // O erro era garantido. O uso da função (o () => { ... }) garante que a verificação rode apenas uma vez na inicialização.

  const [user, setUser] = useState(null);

  // Opcional: Apenas para carregar os dados do usuário se o token existir
  useEffect(() => {
    const token = localStorage.getItem("ClientToken");

    if (token && !user) {
      // Em uma aplicação real, aqui você faria uma chamada à API para pegar os dados do usuário (ex: GET /api/me).
      // Por agora, apenas definimos como true e carregamos os dados fake se houver token.
      setIsAuthenticated(true);
      // Aqui você faria o setUser(dados_reais)
    } else if (!token && isAuthenticated) {
      // Se o token sumiu (ex: expirou no servidor e foi limpo), forçamos o logout no cliente
      setIsAuthenticated(false);
    }
  }, [isAuthenticated, user]);

  const login = (token, userData) => {
    localStorage.setItem("ClientToken", token);
    setIsAuthenticated(true);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("ClientToken");
    setIsAuthenticated(false); // <--- DEVE ESTAR AQUI
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
